<template>
  <div v-if="!$route.meta.hideHeader" class="m-header white-bg flex items-center justify-between">
    <div class="m-search-box flex flex-1 ">
      <div class="m-search-box-input flex flex-1 items-center">
        <i class="m-search-box-input-icon iconfont icon-sousuo"></i>
        <input v-model="keyword" maxlength="30" type="text" class="m-search-box-input-input f14" placeholder="请输入搜索内容" />
      </div>
      <router-link :to="`/goods/type?keyword=${keyword}`">
        <com-button class-name="m-seach-btn" label="搜索"/>
      </router-link>
    </div>
    <!-- 显示学制、学籍弹窗 按钮 -->
    <div @click="show = true">
      <icon class="book-type-btn" icon-name="icon-caidan" />
    </div>
    <!-- 学制、学籍弹窗 -->
    <van-popup
      v-model="show"
      closeable
      position="bottom"
      :style="{ maxHeight: '80%' }"
    >
      <section class="academic-container">
        <div class="academic-title white-bg flex items-center main-cl bold">适用学制及学籍</div>
        <div>
          <van-collapse v-model="activeNames">
            <van-collapse-item 
              v-for="book_type in bookTypeList"
              :key="book_type.name"
              :title="book_type.name"
              :name="book_type.name"
            >
              <nav class="academic-children flex flex-wrap">
                <div 
                  v-for="item in book_type.Children"
                  :key="item.id"
                  @click="goBookTypes(item.id)"
                  class="academic-child flex items-center justify-center"
                >{{item.name}}</div>
              </nav>
            </van-collapse-item>
          </van-collapse>
        </div>
      </section>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      show: false,
      activeNames: [],
      keyword: '',
    }
  },
  computed:{
    ...mapState(['bookTypeList']),
  },
  created(){
    this.activeNames = this.bookTypeList.map(item => item.name)
  },
  methods: {
    onClick() {
      this.show = true;
    },
    // 跳转对应书记类型列表
    goBookTypes(id){
      this.show = false;
      this.$router.push(`/goods/type/${id}`)
    }
  },
}
</script>

<style lang="less" scoped>
  .m-header {
    padding: .3rem;

    @searchHeight: .75rem;
    .m-search-box{
      background: #f2f2f2;
      height: @searchHeight;
      border-radius: @searchHeight;

      &-input{ 
        padding-left: .42rem;

        &-icon{
          margin-right: .16rem;
        }
        &-input{
          padding-left: .2rem;
        }
      }
      .m-seach-btn{
        height: 100%;
        width: 1.4rem;
        font-size: .3rem;
      }
    }

    .book-type-btn{
      margin-left: .2rem;
      margin-right: 0;
      padding: 0;
      width: @searchHeight;
      height: @searchHeight;
      font-size: .32rem;
    }
  }
  @academicTitleH: .92rem;
  // 移动端弹窗
  .academic-title{
    font-size: .32rem;
    padding: 0 .3rem;
    height: @academicTitleH;
    border-bottom: 1px solid #C9D1D3;
    // position: absolute;
    // width: 100%;
    // top: 0;
    // left: 0;
    // z-index: 9;
  }
  .academic-child{
    width: 2.18rem;
    height: .7rem;
    border-radius: .1rem;
    border: 1px solid #878787;
    margin-right: .18rem;
    margin-bottom: .3rem;
    &:nth-of-type(3n){
      margin-right: 0;
    }
  }
  // .academic-container {
  //   padding-top: 0.92rem;

  //   .academic-title{
  //     position: absolute;
  //     width: 100%;
  //     top: 0;
  //     left: 0;
  //     z-index: 9;
  //   }
  // }
  // 重置vant-collapse 样式
  .academic-container /deep/.van-cell__title>span{
    font-size: .28rem;
    color: #333;
    font-weight: bold;
  }
  .academic-container /deep/.van-collapse-item__content{
    padding-left: .3rem;
    padding-bottom: 0;
    padding-right: .3rem;
  }
  /deep/.van-popup__close-icon--top-right{
    top: @academicTitleH / 2;
    transform: translateY(-50%);
  }
</style>
